import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0;
  margin: 0;
  overflow-y: scroll;
`;

const StyledInput = styled(Ui.Input)`
  width: 100%;
  margin: ${({ theme }) => theme.spacing[50]} 0;
  position: sticky;
  top: 0;
  z-index: 10;
`;

const SuggestionWrapper = styled.ul`
  position: relative;
  top: ${({ theme }) => theme.spacing[10]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[40]};
`;

const StyledButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  font-style: inherit;
  color: inherit;
  width: 100%;
  height: 2.8125rem;
  display: grid;
  grid-template-columns: ${({ theme }) => theme.spacing[60]} 1fr;
  grid-template-rows: repeat(2, ${({ theme }) => theme.spacing[40]});
  grid-gap: 0 ${({ theme }) => theme.spacing[40]};
  justify-items: start;
  background-color: ${({ theme }) => theme.color.white};
`;

const IconWrapper = styled.div`
  grid-area: 1 / 1 / 3 / 2;
  width: ${({ theme }) => theme.spacing[60]};
  height: ${({ theme }) => theme.spacing[60]};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Country = styled.div`
  grid-area: 1 / 2 / 2 / 3;
  color: ${({ theme }) => theme.color.grey02};
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: ${({ theme }) => theme.fontSize.xs.size};
  font-weight: ${({ theme }) => theme.fontWeight.body};
  line-height: 1.5;
`;

const Station = styled.div`
  grid-area: 2 / 2 / 3 / 3;
  color: ${({ theme }) => theme.color.text};
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: ${({ theme }) => theme.fontSize.sm.size};
  font-weight: ${({ theme }) => theme.fontWeight.heading};
  line-height: 1.5;
`;

const ErrorMessage = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  background-color: ${({ theme }) => theme.color.error};
  color: ${({ theme }) => theme.color.white};
  font-size: 0.75rem;
  border: 0;
  border-radius: 0;
  box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
  padding: ${({ theme }) => theme.spacing[40]};
  z-index: 3;
`;

export {
  Container,
  StyledInput,
  SuggestionWrapper,
  StyledButton,
  IconWrapper,
  Country,
  Station,
  ErrorMessage,
};
